import type { IStageToolbarConfig, StageToolbarConfigInput } from './types';

export const DEFAULT_STAGE_TOOLBAR_CONFIG: IStageToolbarConfig = {
    appearance: 'standard',
    position: 'right',
    items: {
        referenceLines: true,
        hierarchy: {
            mode: 'panel',
        },
        scale: {
            mode: 'menu',
            showCanvasSize: true,
        },
        fitViewport: false,
        customNode: true,
    },
};

/**
 * setConfig 使用整体替换语义：每次都从标准工具栏默认值补齐缺省项。
 * 条目的显式 false 必须保留，不能在归一化时被默认开启状态覆盖。
 */
export const normalizeStageToolbarConfig = (config: StageToolbarConfigInput): IStageToolbarConfig => {
    const items = config.items || DEFAULT_STAGE_TOOLBAR_CONFIG.items;
    const defaultHierarchy = DEFAULT_STAGE_TOOLBAR_CONFIG.items.hierarchy as Exclude<
        IStageToolbarConfig['items']['hierarchy'],
        false
    >;
    const defaultScale = DEFAULT_STAGE_TOOLBAR_CONFIG.items.scale as Exclude<
        IStageToolbarConfig['items']['scale'],
        false
    >;

    return {
        appearance: config.appearance || DEFAULT_STAGE_TOOLBAR_CONFIG.appearance,
        position: config.position || DEFAULT_STAGE_TOOLBAR_CONFIG.position,
        itemOrder: config.itemOrder ? [...config.itemOrder] : undefined,
        items: {
            referenceLines: items.referenceLines ?? DEFAULT_STAGE_TOOLBAR_CONFIG.items.referenceLines,
            hierarchy:
                items.hierarchy === false
                    ? false
                    : {
                          mode: items.hierarchy?.mode || defaultHierarchy.mode,
                          hideWhenAgentLayoutEnabled:
                              items.hierarchy?.hideWhenAgentLayoutEnabled ??
                              defaultHierarchy.hideWhenAgentLayoutEnabled,
                      },
            scale:
                items.scale === false
                    ? false
                    : {
                          mode: items.scale?.mode || defaultScale.mode,
                          showCanvasSize: items.scale?.showCanvasSize ?? defaultScale.showCanvasSize,
                      },
            fitViewport: items.fitViewport ?? DEFAULT_STAGE_TOOLBAR_CONFIG.items.fitViewport,
            customNode: items.customNode ?? DEFAULT_STAGE_TOOLBAR_CONFIG.items.customNode,
        },
    };
};
